import Velocity from 'velocity-animate';

import Component from '../../components/component/component';
import Helpers from '../../components/helpers/helpers';
import AjaxPage from '../ajax/ajax-page';

import './intro.scss';

export interface IIntroSettings {
    animatingClass: string;
    columnSelector: string;
    gridSelector: string;
    fadeInClass: string;
    fadeOutClass: string;
    selectedClass: string;
}

const returnStringBasedOnIndex: (index: number) => string = (index: number): string => {
    switch (index) {
        case 0:
            return 'first';
        case 1:
            return 'second';
        case 2:
            return 'third';
    }
};

export default class Intro extends Component {
    static initSelector: string = '.intro';

    column: JQuery;
    grid: JQuery;
    isAnimating: boolean = false;
    settings: IIntroSettings;
    timeout: number;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            animatingClass: 'is-animating',
            columnSelector: '.intro__col',
            gridSelector: '.intro__grid',
            fadeInClass: 'fade-in',
            fadeOutClass: 'fade-out',
            selectedClass: 'is-selected',
        };

        this.grid = this.element.find(this.settings.gridSelector);
        this.column = this.element.find(this.settings.columnSelector);

        this.init();
    }

    init(): void {
        this.column.each((index: number, element: HTMLElement) => {
            window.setTimeout(() => {
                $(element).addClass(this.settings.fadeInClass);
            }, index * 800);
        });

        this.column.on('click', this.onClick.bind(this));
        this.column.on('mouseenter', this.onMouseEnter.bind(this));
        this.column.on('mouseleave', this.onMouseLeave.bind(this));
    }

    onClick(event: JQuery.ClickEvent): void {
        event.preventDefault();

        if (!this.isAnimating) {
            this.isAnimating = true;
            this.startAnimation(event.currentTarget);
        }
    }

    onMouseEnter(event: JQuery.MouseEnterEvent): void {
        const columnModifier: string = returnStringBasedOnIndex($(event.currentTarget).index());

        this.grid.addClass(`is-hovering-${columnModifier}`);
    }

    onMouseLeave(event: JQuery.MouseEnterEvent): void {
        const columnModifier: string = returnStringBasedOnIndex($(event.currentTarget).index());

        this.grid.removeClass(`is-hovering-${columnModifier}`);
    }

    startAnimation(targetElement: HTMLElement): void {
        const target: JQuery = $(targetElement);
        const url: string = target.attr('href');

        target.addClass(this.settings.selectedClass);
        this.column.each((_index: number, element: HTMLElement) => {
            if (targetElement !== element) {
                $(element).addClass(this.settings.fadeOutClass);

                if (!window.matchMedia('(min-width: ' + Helpers.bp.lg + 'px)').matches) {
                    Velocity($(element), {
                        height: 0,
                    }, {
                        complete: Helpers.scrollToNumber(0),
                        duration: 600,
                        easing: [.8, 0, .2, 1],
                    });
                }
            }
        });

        this.element.addClass(this.settings.animatingClass);

        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }

        AjaxPage.preloadPage(url);
        // Equal to intro__col max-width transition + delay (600ms + $transition-duration * 2)
        this.timeout = window.setTimeout(() => AjaxPage.changePage(url), 1400);
    }
}
